import { SelfOnboardingCompleteGuard } from './self-onboarding-complete.guard';

const Guards = [SelfOnboardingCompleteGuard];

export { SelfOnboardingCompleteGuard, Guards };
